<section class="moedas-department-cards">
  <div class="moedas-department-cards__container">
    <ng-container *ngFor="let item of departments">
      <app-cards [departaments]="item"></app-cards>
    </ng-container>
  </div>
</section>
